import script from "./GGanttBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./GGanttBar.vue?vue&type=script&setup=true&lang=ts"

import "./GGanttBar.vue?vue&type=style&index=0&id=7ae5bbb4&lang=css"

const __exports__ = script;

export default __exports__